(function () {
  'use strict';

  function openCheckoutCapture(payload, root) {
    if (root) {
      var exitWebhookUrl = root.getAttribute('data-webhook-url') || '';
      if (exitWebhookUrl) {
        payload.webhookUrl = exitWebhookUrl;
      }
    }

    if (!payload.webhookUrl && window.GhostCheckoutCapture && window.GhostCheckoutCapture.getWebhookUrl) {
      payload.webhookUrl = window.GhostCheckoutCapture.getWebhookUrl();
    }

    if (window.GhostCheckoutCapture && window.GhostCheckoutCapture.open(payload)) {
      return;
    }

    window.setTimeout(function () {
      if (window.GhostCheckoutCapture) {
        window.GhostCheckoutCapture.open(payload);
      }
    }, 0);
  }

  function buildPurchasePayload(buyButton) {
    var modelName = buyButton.getAttribute('data-model-name') || '';
    var variantLabel = buyButton.getAttribute('data-variant-label') || '';
    var fullName = variantLabel ? modelName + ' – ' + variantLabel : modelName;

    return {
      checkoutUrl: buyButton.getAttribute('data-checkout-url') || '',
      imageUrl: buyButton.getAttribute('data-image-url') || '',
      modelName: fullName,
      variantId: buyButton.getAttribute('data-variant-id') || '',
      type: 'purchase',
      source: 'exit_popup',
      pageUrl: window.location.href
    };
  }

  function initSection(root) {
    if (!root || root.dataset.exitPopupInit === 'true') return;
    root.dataset.exitPopupInit = 'true';

    var overlay = root.querySelector('[data-exit-popup-overlay]');
    var dialog = root.querySelector('[data-exit-popup-dialog]');
    var closeButtons = root.querySelectorAll('[data-exit-popup-close]');
    var storageKey = root.getAttribute('data-storage-key') || 'ghost-exit-popup-dismissed';
    var focus = window.GhostModalFocus;
    var opened = false;
    var dismissed = false;

    if (window.location.search.indexOf('ghost_reset_exit=1') >= 0) {
      sessionStorage.removeItem(storageKey);
    }

    dismissed = !!sessionStorage.getItem(storageKey);

    function openPopup() {
      if (!overlay || dismissed || opened) return;
      opened = true;
      root.removeAttribute('hidden');
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('ghost-exit-popup-open');
      if (focus) focus.rememberFocus();
      window.requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
        if (focus && dialog) focus.focusInitial(dialog, '[data-exit-popup-close]');
      });
    }

    function closePopup() {
      if (!overlay) return;
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ghost-exit-popup-open');
      sessionStorage.setItem(storageKey, '1');
      dismissed = true;
      window.setTimeout(function () {
        overlay.hidden = true;
        if (focus) focus.restoreFocus();
      }, 280);
    }

    function getActiveVariantButton(productCard) {
      return productCard.querySelector('[data-exit-popup-variant].is-active') ||
        productCard.querySelector('[data-exit-popup-variant]');
    }

    function syncProductCard(productCard) {
      var activeVariant = getActiveVariantButton(productCard);
      var buyButton = productCard.querySelector('[data-exit-popup-buy]');
      var image = productCard.querySelector('[data-exit-popup-image]');
      var compareNode = productCard.querySelector('[data-exit-popup-compare]');
      var installmentNode = productCard.querySelector('[data-exit-popup-installment]');

      if (!buyButton) return;

      if (!activeVariant) {
        return;
      }

      if (image && activeVariant.getAttribute('data-image-url')) {
        image.src = activeVariant.getAttribute('data-image-url');
      }

      if (compareNode) {
        var comparePrice = activeVariant.getAttribute('data-compare-price') || '';
        if (comparePrice) {
          compareNode.textContent = comparePrice;
          compareNode.hidden = false;
        } else {
          compareNode.hidden = true;
        }
      }

      if (installmentNode) {
        installmentNode.textContent = activeVariant.getAttribute('data-installment-price') || installmentNode.textContent;
      }

      var accentColor = activeVariant.getAttribute('data-accent-color');
      var accentDim = activeVariant.getAttribute('data-accent-dim');
      var accentBorder = activeVariant.getAttribute('data-accent-border');
      var cardBg = activeVariant.getAttribute('data-card-bg');
      var cardGlow = activeVariant.getAttribute('data-card-glow');

      if (accentColor) productCard.style.setProperty('--exit-accent', accentColor);
      if (accentDim) productCard.style.setProperty('--exit-accent-dim', accentDim);
      if (accentBorder) productCard.style.setProperty('--exit-accent-border', accentBorder);
      if (cardBg) productCard.style.setProperty('--exit-card-bg', cardBg);
      if (cardGlow) productCard.style.setProperty('--exit-card-glow', cardGlow);

      buyButton.setAttribute('data-checkout-url', activeVariant.getAttribute('data-checkout-url') || buyButton.getAttribute('data-checkout-url') || '');
      buyButton.setAttribute('data-image-url', activeVariant.getAttribute('data-image-url') || buyButton.getAttribute('data-image-url') || '');
      buyButton.setAttribute('data-variant-label', activeVariant.getAttribute('data-label') || buyButton.getAttribute('data-variant-label') || '');
      buyButton.setAttribute('data-variant-id', activeVariant.getAttribute('data-variant-id') || buyButton.getAttribute('data-variant-id') || '');
    }

    root.querySelectorAll('[data-exit-popup-product]').forEach(function (productCard) {
      syncProductCard(productCard);
    });

    root.addEventListener('click', function (event) {
      var variantButton = event.target.closest('[data-exit-popup-variant]');
      if (variantButton) {
        event.preventDefault();
        event.stopPropagation();
        var productCard = variantButton.closest('[data-exit-popup-product]');
        if (!productCard) return;

        productCard.querySelectorAll('[data-exit-popup-variant]').forEach(function (button) {
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
        });
        variantButton.classList.add('is-active');
        variantButton.setAttribute('aria-pressed', 'true');
        syncProductCard(productCard);
        return;
      }

      var buyButton = event.target.closest('[data-exit-popup-buy]');
      if (buyButton) {
        event.preventDefault();
        event.stopPropagation();
        openCheckoutCapture(buildPurchasePayload(buyButton), root);
        return;
      }

      var productCard = event.target.closest('[data-exit-popup-product]');
      if (productCard) {
        var cardBuyButton = productCard.querySelector('[data-exit-popup-buy]');
        if (cardBuyButton) {
          event.preventDefault();
          openCheckoutCapture(buildPurchasePayload(cardBuyButton), root);
        }
        return;
      }

      if (event.target.closest('[data-exit-popup-close]')) {
        event.preventDefault();
        closePopup();
        return;
      }

      if (event.target === overlay) {
        closePopup();
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay && !overlay.hidden) {
        closePopup();
      }

      if (event.key === 'Tab' && overlay && !overlay.hidden && focus && dialog) {
        focus.trapTab(event, dialog);
      }
    });

    if (dismissed) return;

    var desktopDelay = parseInt(root.getAttribute('data-desktop-delay') || '0', 10);
    var mobileDelay = parseInt(root.getAttribute('data-mobile-delay') || '0', 10);
    var enableMobile = root.getAttribute('data-enable-mobile') === 'true';
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var readyAt = Date.now() + (isMobile ? mobileDelay : desktopDelay) * 1000;
    var exitArmed = false;

    function canFire() {
      return !dismissed && !opened && Date.now() >= readyAt;
    }

    function isExitIntent(event) {
      if (typeof event.clientY === 'number' && event.clientY <= 20) {
        return true;
      }

      var related = event.relatedTarget || event.toElement;
      return !related;
    }

    function handleExitIntent(event) {
      if (!canFire()) return;

      if (isMobile) {
        if (!enableMobile) return;
        openPopup();
        return;
      }

      if (isExitIntent(event)) {
        openPopup();
      }
    }

    function armExitIntent() {
      if (exitArmed || dismissed || opened) return;
      exitArmed = true;

      document.documentElement.addEventListener('mouseleave', handleExitIntent);
      document.documentElement.addEventListener('mouseout', handleExitIntent);
    }

    if (isMobile && enableMobile) {
      window.setTimeout(function () {
        if (canFire()) openPopup();
      }, Math.max(mobileDelay, 1) * 1000);
    } else if (!isMobile) {
      window.setTimeout(armExitIntent, Math.max(desktopDelay, 0) * 1000);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ghost-exit-popup]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ghost-exit-popup]');
    if (section) initSection(section);
  });
})();
